import { Injectable } from '@angular/core';
import { CodeService } from './code.service';
import { Injector } from '../../core/injector/injector';
import { BaseService } from '../../core';
import updateLocale from 'dayjs/plugin/updateLocale';
import dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
// dayjs.extend(updateLocale);

@Injectable({
  providedIn: 'root',
})
export class AppLoadService extends BaseService {
  private codeService: CodeService;
  constructor(private injector: Injector) {
    super();
    this.codeService = Injector.get(CodeService);
  }

  async initSetting() {
    try {
      // 상용시 console.log 무효화
      if (environment.env !== 'dev') {
        console.log = () => {};
        console.warn = () => {};
        console.error = () => {};
      }
      return await Promise.all([
        this.__refreshJwtToken(),
        this.__init_api(),
        this.codeService.initCommonCode(),
        // this.codeService.initSalesCategory(),
        this.codeService.initDisplayCategory(),
        this.codeService.initCallingCode(),
        this.codeService.initCountryCode(),
      ]);
    } catch (e) {}
  }

  private async __refreshJwtToken() {}
  private async __init_api() {
    const init = await this.get<any>('/global/init').toPromise();
    console.log('AppLoadService.initSetting.__init_api', init);
    return init;
  }
}
